import { render, staticRenderFns } from "./DeviceUpgradeFile.vue?vue&type=template&id=affb2d4a&scoped=true&"
import script from "./DeviceUpgradeFile.vue?vue&type=script&lang=js&"
export * from "./DeviceUpgradeFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affb2d4a",
  null
  
)

export default component.exports